import { InitPagedData } from "./../Utils";
import { FuelStateTypes, FuelActionTypes } from "./Fuel.type";
import { resetApiCallState } from "../Utils";
import Fuel from "../../components/Operation/Fuel";

const INITIAL_STATE: FuelStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchPaged: resetApiCallState(InitPagedData),
};

const FuelReducer = (
  state: FuelStateTypes = INITIAL_STATE,
  action: any
): FuelStateTypes => {
  switch (action.type) {
    case FuelActionTypes.FETCH_ALL_FUEL:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelActionTypes.FETCH_ALL_FUEL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FuelActionTypes.FETCH_ALL_FUEL_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelActionTypes.FETCH_ALL_FUEL_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };
    case FuelActionTypes.FETCH_PAGED_FUEL:
      return {
        ...state,
        fetchPaged: {
          error: null,
          payload: InitPagedData,
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelActionTypes.FETCH_PAGED_FUEL_RESET:
      return {
        ...state,
        fetchPaged: resetApiCallState(InitPagedData),
      };
    case FuelActionTypes.FETCH_PAGED_FUEL_FAILURE:
      return {
        ...state,
        fetchPaged: {
          payload: InitPagedData,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelActionTypes.FETCH_PAGED_FUEL_SUCCESS:
      return {
        ...state,
        fetchPaged: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FuelActionTypes.FETCH_ONE_FUEL:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelActionTypes.FETCH_ONE_FUEL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FuelActionTypes.FETCH_ONE_FUEL_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelActionTypes.FETCH_ONE_FUEL_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FuelReducer;
